import { render, staticRenderFns } from "./Checkboard.vue?vue&type=template&id=735deb43&"
import script from "./Checkboard.vue?vue&type=script&lang=js&"
export * from "./Checkboard.vue?vue&type=script&lang=js&"
import style0 from "./Checkboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports